import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { GridContainer, GridItem } from '../../components';
import { Box, CircularProgress, Fab } from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import DoneIcon from '@material-ui/icons/Done';
import Typography from '@material-ui/core/Typography';

export const ResponseSuccess = () => {
    const [isLoading, setIsLoading] = React.useState(true);
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    React.useEffect(()=>{
        searchParams.append("redirectResult", "success");
        setSearchParams(searchParams);
    }, []);

    React.useEffect(()=>{
        const loadingTimeout = setTimeout(()=>{
            setIsLoading(false);
        },3000);

        return () => clearTimeout(loadingTimeout);
    },[searchParams, setSearchParams]);

    React.useEffect(()=>{
        if(!isLoading){
            const newURL = `/checkin?${searchParams.toString()}`;
            navigate(newURL);
        }
    }, [isLoading, navigate]);

    return (
        <GridContainer
            spacing={3}
            alignContent="center"
            justifyContent="center"
            direction="row"
            style={{ paddingTop: '32px', paddingLeft: '18px', paddingRight: '18px', height: '50vh' }}
            >
            <GridItem xs={12}>
                <Typography align="center" variant="h3">
                Thank You 
                </Typography>
            </GridItem>
            <GridItem xs={12}>
                <Typography align="center" variant="body1">
                PLEASE WAIT...
                </Typography>
            </GridItem>
            <GridItem xs={12}>
                <Typography align="center" variant="body1" style={{ fontStyle: 'italic' }}>
                Returning you to merchant's website
                </Typography>
            </GridItem>
            <GridItem>
                <Box sx={{ m: 1, position: 'relative' }}>
                    <Fab style={{ backgroundColor: green[500] }}>
                    <DoneIcon
                        style={{
                        color: 'white'
                        }}
                    />
                    </Fab>
                    <CircularProgress
                    size={68}
                    style={{
                        color: green[500],
                        position: 'absolute',
                        top: -6,
                        left: -6,
                        zIndex: 1
                    }}
                    />
                </Box>
            </GridItem>
        </GridContainer>
    );
};
